/**
 * 只要有一个不满足条件就返回 false
 * @param arr
 * @param func
 */
var every = function (arr, func) {
  for (var i = 0; i < arr.length; i++) {
    if (!func(arr[i], i)) return false;
  }
  return true;
};
export default every;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_util@2.0.17@@antv/util/esm/every.js
// module id = 55
// module chunks = 0